import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button, Alert } from 'reactstrap';
import { getClientQuotations } from '../../../../../../redux/actions/client';

const QuotationData = ({ clientId }) => {
  const dispatch = useDispatch();
  const quotationState = useSelector((state) => state.client.getQuotations);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (clientId) {
      dispatch(getClientQuotations(clientId));
    }
  }, [clientId, dispatch]);

  useEffect(() => {
    if (quotationState) {
      setLoading(false);
      if (quotationState.status === 'danger') {
        setError(quotationState.message);
      } else {
        setError(null);
      }
    }
  }, [quotationState]);

  const handleDownloadQuotation = (pdf) => {
    window.open(pdf, '_blank');
  };

  if (loading) {
    return <div>Cargando cotizaciones...</div>;
  }

  return (
    <>
      <h4 className="mt-0">Cotizaciones</h4>

      {error && (
        <Alert color="danger">
          Error: {error || 'No se pudieron cargar las cotizaciones'}
        </Alert>
      )}

      {!error && (
        <Table responsive hover>
          <thead>
            <tr>
              <th>Nro de Cotización</th>
              <th>Número Interno</th>
              <th>Versión</th>
              <th>Precio</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {quotationState.data && quotationState.data.length > 0 ? (
              quotationState.data.map((quotation) => (
                <tr key={quotation.id}>
                  <td>{quotation.id || '--'}</td>
                  <td>{quotation.data.numerointerno || '--'}</td>
                  <td>{quotation.data.version || '--'}</td>
                  <td>
                    {quotation.data.price
                      ? `$${quotation.data.price.toLocaleString('es-CL')}`
                      : '--'}{' '}
                    {quotation.data.iva}
                  </td>
                  <td>
                    {quotation.data.date
                      ? new Date(quotation.data.date).toLocaleDateString(
                          'es-CL',
                        )
                      : '--'}
                  </td>
                  <td>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() =>
                        handleDownloadQuotation(quotation.data.pdf)
                      }
                    >
                      Descargar
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No hay cotizaciones disponibles
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default QuotationData;
